import { AlertTriangle, CalendarCheck, CalendarClock, CalendarRange, CheckCircle2, MailX, PhoneCall, Users } from "lucide-react";

const Stat = ({ label, value, icon: Icon, accent, onClick, testid, delay }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className="rise group flex items-center justify-between rounded-xl border border-slate-700/60 bg-slate-800/60 p-4 text-left transition-colors duration-200 hover:border-slate-500 sm:p-5"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className="min-w-0">
      <div className="truncate text-xs font-medium uppercase tracking-wider text-slate-400">{label}</div>
      <div className="mt-1 font-display text-3xl font-bold" data-testid={`${testid}-value`}>{value ?? "–"}</div>
    </div>
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg transition-transform duration-200 group-hover:scale-110" style={{ background: `${accent}22`, color: accent }}>
      <Icon className="h-5 w-5" />
    </span>
  </button>
);

export const StatsStrip = ({ summary, monthName, onSelect }) => {
  const s = summary?.stats;
  const items = [
    ["Clientes ativos", s?.active_clients, Users, "#94A3B8", "clientes", "stat-active-clients"],
    [monthName, s?.current_month, CalendarCheck, "#F8FAFC", "mes", "stat-current-month"],
    ["Próximo mês", s?.next_month, CalendarRange, "#6366F1", "planejamento", "stat-next-month"],
    ["Atrasados", s?.overdue, AlertTriangle, "#F43F5E", "alertas", "stat-overdue"],
    ["Contatos pendentes", s?.pending_contacts, PhoneCall, "#F59E0B", "planejamento", "stat-pending-contacts"],
    ["Confirmados", s?.confirmed, CheckCircle2, "#10B981", "planejamento", "stat-confirmed"],
    ["Mensagens com falha", s?.failed_messages, MailX, "#FB7185", "mensagens", "stat-failed-messages"],
    ["Próximos atendimentos", summary?.upcoming.length, CalendarClock, "#06B6D4", "proximos", "stat-upcoming"],
  ];
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 lg:gap-4" data-testid="stats-strip">
      {items.map(([label, value, icon, accent, tab, testid], i) => (
        <Stat key={testid} label={label} value={value} icon={icon} accent={accent} onClick={() => onSelect(tab)} testid={testid} delay={i * 40} />
      ))}
    </div>
  );
};
